import { InputDimensions } from "#components/atoms/InputDimensions/InputDimensions";
import { Material } from "#modules/materials/infra/fetchCustomMaterials.api";
import { UpdateMaterialDto } from "#modules/materials/infra/updateMaterial.api";
import { FieldConfig, getMaterialDimensionsFieldsConfiguration } from "shared";

type DimensionsCellProps = {
  material: Material;
  onUpdate: (payload: UpdateMaterialDto) => void;
};

export const DimensionsCell = ({ material, onUpdate }: DimensionsCellProps) => {
  const config = getMaterialDimensionsFieldsConfiguration(material.type);

  const valueFor = (fieldConfig: FieldConfig) => material[fieldConfig.field] ?? undefined;

  const handlerFor = (key: FieldConfig["key"]) => {
    const fieldConfig = config.find((field) => field.key === key);
    if (!fieldConfig) {
      return undefined;
    }

    return (value: number | undefined) => {
      if (value === undefined) {
        return;
      }

      const payload: UpdateMaterialDto = { [fieldConfig.field]: value };
      if (fieldConfig.syncWith) {
        payload[fieldConfig.syncWith] = value;
      }
      onUpdate(payload);
    };
  };

  const valueByKey = Object.fromEntries(config.map((field) => [field.key, valueFor(field)]));

  return (
    <InputDimensions
      dimensions={config.map((field) => field.key)}
      thickness={valueByKey.thickness}
      diameter={valueByKey.diameter}
      height={valueByKey.height}
      width={valueByKey.width}
      length={valueByKey.length}
      onThicknessChange={handlerFor("thickness")}
      onDiameterChange={handlerFor("diameter")}
      onHeightChange={handlerFor("height")}
      onWidthChange={handlerFor("width")}
      onLengthChange={handlerFor("length")}
    />
  );
};
